export default function SponsorController(
  $scope,
  $state,
  sponsorService,
  DestinationService,
  countryService,
  sessionService,
  UtilService,
  SPONSOR_TYPES,
  SPONSOR_STATUSES,
  calendarConfig,
  calendarEventTitle,
) {
  var vm = this;

  vm.isLoading = false;
  vm.allSponsors = [];
  vm.sponsorCount = {};
  vm.listedSponsors = [];
  vm.listedSponsorsType = SPONSOR_TYPES.HOMEPAGE;
  vm.isSponsorManager = sessionService.hasPermission(['SPONSOR_UPDATE']);
  vm.calendarView = 'month';
  vm.calendarViewDate = moment();
  vm.events = [];

  vm.sponsorParamsDefault = {
    isArchived: false,
    isLive: true,
    isScheduled: true,
    isDeleted: false,
    dateRange: {
      startDate: moment().startOf('month'),
      endDate: moment().endOf('month'),
    },
  };
  vm.sponsor = angular.copy(vm.sponsorParamsDefault);

  vm.options = {
    countries: [],
    cities: [],
    districts: [],
  };
  vm.sponsorTypes = SPONSOR_TYPES;
  vm.sponsorStatuses = SPONSOR_STATUSES;
  vm.sponsorTypeCalendar = SPONSOR_TYPES.HOMEPAGE;

  vm.dateRangePickerOptions = {
    applyClass: 'btn-dark',
    locale: {
      format: 'DD.MM.YYYY',
    },
    ranges: {
      'Last 7 days': [
        moment()
          .startOf('day')
          .subtract(6, 'days'),
        moment().endOf('day'),
      ],
      'Last 30 days': [
        moment()
          .startOf('day')
          .subtract(29, 'days'),
        moment().endOf('day'),
      ],
      'Last month': [
        moment()
          .subtract(1, 'month')
          .startOf('month'),
        moment()
          .subtract(1, 'month')
          .endOf('month'),
      ],
      'This month': [moment().startOf('month'), moment().endOf('month')],
      'Next 3 months': [
        moment().startOf('day'),
        moment()
          .endOf('day')
          .add(3, 'month'),
      ],
    },
  };

  vm.init = init;
  vm.getDistricts = getDistricts;
  vm.onCountryChange = onCountryChange;
  vm.getCities = getCities;
  vm.onCityChange = onCityChange;
  vm.getSponsors = getSponsors;
  vm.clearParams = clearParams;
  vm.filterSponsors = filterSponsors;
  vm.setListedSponsorsType = setListedSponsorsType;
  vm.loadAddNewSponsorPage = loadAddNewSponsorPage;
  vm.loadEditSponsorPage = loadEditSponsorPage;
  vm.getAvaibilityCalendar = getAvaibilityCalendar;
  vm.cellModifier = cellModifier;

  // watch for date-range picker changes
  $scope.$watch('vm.sponsor.dateRange', getSponsors);

  init();

  function init() {
    getCountries();
    calendarEventTitle.monthView = function hideEventStartTime(event) {
      return event.title;
    };
  }

  function getCountries() {
    countryService.getAllCountries().then(function(res) {
      if (res && res.data) {
        vm.options.countries = res.data;
      }
    });
  }

  function onCountryChange() {
    getCities();
    getSponsors();
  }

  function getCities() {
    if (!vm.sponsor.countryId) {
      vm.options.cities = [];
      return;
    }
    return getChildrenDestination(vm.sponsor.countryId, 'city').then(function(res) {
      vm.options.cities = res.data;
    });
  }

  function onCityChange() {
    getDistricts();
    getSponsors();
  }

  function getDistricts() {
    if (!vm.sponsor.cityId) {
      vm.options.districts = [];
      return;
    }
    return getChildrenDestination(vm.sponsor.cityId, 'district').then(function(res) {
      vm.options.districts = res.data;
    });
  }

  function getChildrenDestination(parentId, destinationType) {
    var params = UtilService.generateSearchUrl({ destination_type: destinationType });
    return DestinationService.getDestinationChildren(parentId, params);
  }

  function getSponsors() {
    if (vm.isLoading || !vm.sponsor.dateRange.startDate || !vm.sponsor.dateRange.endDate) {
      return;
    }
    enableLoading();

    var destinationId = getDestinationId();

    sponsorService
      .getSponsors(vm.sponsor.dateRange.startDate, vm.sponsor.dateRange.endDate, destinationId)
      .then(function(res) {
        vm.allSponsors = res.data;
      })
      .then(filterSponsors)
      .then(getAvaibilityCalendar)
      .finally(disableLoading);
  }

  function getAvaibilityCalendar() {
    if (!vm.sponsor.countryId) {
      return;
    }

    vm.events = [];
    var month = moment(vm.calendarViewDate).format('MM'),
      year = moment(vm.calendarViewDate).format('YYYY'),
      startDate = moment([year, month - 1]),
      endDate = moment(startDate).endOf('month');

    var destinationId = getDestinationId();

    sponsorService.getSponsorsAvailability(startDate, endDate, destinationId, vm.sponsorTypeCalendar).then(function(res) {
      var sponsoredMerchants = res.data;
      sponsoredMerchants.forEach(addEvent);
    });
  }

  function getDestinationId() {
    return vm.sponsor.districtId ? vm.sponsor.districtId : vm.sponsor.cityId ? vm.sponsor.cityId : vm.sponsor.countryId;
  }

  function addEvent(sponsor) {
    vm.events.push({
      title:
        'Restaurant:(Id: ' +
        sponsor.merchantId +
        ') ' +
        sponsor.merchantName +
        ' - Start/End: ' +
        formatSponsorDate(sponsor.startDate) +
        '/' +
        formatSponsorDate(sponsor.endDate),
      id: sponsor.id,
      startsAt: new Date(sponsor.startDate),
      endsAt: new Date(sponsor.endDate),
      sponsorType: sponsor.sponsorType,
      color: calendarConfig.colorTypes.info,
      draggable: false,
      resizable: false,
    });
  }

  function formatSponsorDate(date) {
    return moment(date).format('DD-MM-YYYY');
  }

  function cellModifier(cell) {
    var maxEvents = null,
      homepageMaxEvents = 3,
      listingPageMaxEvents = 4,
      availableClass = 'available',
      busyClass = 'busy';

    if (cell.events.length) {
      cell.events.forEach(function(event) {
        if (event.sponsorType === 'HOMEPAGE') {
          maxEvents = homepageMaxEvents;
        } else {
          maxEvents = listingPageMaxEvents;
        }
      });
      if (cell.events.length < maxEvents && cell.inMonth) {
        cell.cssClass = availableClass;
      }
      if (cell.events.length === maxEvents) {
        cell.cssClass = busyClass;
      }
    }
  }

  function filterSponsors() {
    // filter by sponsor status
    vm.listedSponsors = vm.allSponsors.filter(function(sponsor) {
      return (
        (vm.sponsor.isArchived && sponsor.status === SPONSOR_STATUSES.ARCHIVED) ||
        (vm.sponsor.isLive && sponsor.status === SPONSOR_STATUSES.LIVE) ||
        (vm.sponsor.isScheduled && sponsor.status === SPONSOR_STATUSES.SCHEDULED) ||
        (vm.sponsor.isDeleted && sponsor.status === SPONSOR_STATUSES.DELETED)
      );
    });

    // count results before filter by sponsor type
    countResults();

    // filter by sponsor type
    vm.listedSponsors = vm.listedSponsors.filter(function(sponsor) {
      return sponsor.sponsorType === vm.listedSponsorsType;
    });
  }

  function countResults() {
    vm.sponsorCount[SPONSOR_TYPES.HOMEPAGE] = 0;
    vm.sponsorCount[SPONSOR_TYPES.LISTING] = 0;

    angular.forEach(vm.listedSponsors, function(sponsor) {
      if (sponsor.sponsorType === SPONSOR_TYPES.HOMEPAGE || sponsor.sponsorType === SPONSOR_TYPES.LISTING) {
        vm.sponsorCount[sponsor.sponsorType]++;
      }
    });
  }

  function setListedSponsorsType(sponsorsType) {
    vm.listedSponsorsType = sponsorsType;
  }

  function clearParams() {
    vm.options.cities = [];
    vm.sponsor = angular.copy(vm.sponsorParamsDefault);
  }

  function loadAddNewSponsorPage() {
    $scope.listedSponsorsType = vm.listedSponsorsType;
    $state.go('app.sponsors.add');
  }

  function loadEditSponsorPage(sponsorId) {
    if (vm.isSponsorManager) {
      $state.go('app.sponsors.edit', { sponsorId: sponsorId });
    }
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/sponsors/sponsor.controller.js